module.exports = __webpack_public_path__ + "static/media/Statua_049.831beb42.jpg";